__turbopack_context__.v({
  "spin78236": "ThreeDotLoader-module__okUOKW__spin78236",
  "threeBody": "ThreeDotLoader-module__okUOKW__threeBody",
  "threeBodyDot": "ThreeDotLoader-module__okUOKW__threeBodyDot",
  "wobble1": "ThreeDotLoader-module__okUOKW__wobble1",
  "wobble2": "ThreeDotLoader-module__okUOKW__wobble2",
});
